(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-pro"] && !Shopify.designMode) return;
  try {
    
class ContactPro {
  constructor(root) {
    this.root = root;
    this.t = root.dataset;
    this.modeBtns = [...root.querySelectorAll('[data-cp-mode]')];
    this.typeInput = root.querySelector('[data-cp-type]');
    this.body = root.querySelector('[data-cp-body]');
    this.bodyLabel = root.querySelector('[data-cp-body-label]');
    this.submit = root.querySelector('[data-cp-submit]');
    this.submitDefault = this.submit ? this.submit.textContent : '';
    this.zones = [...root.querySelectorAll('[data-cp-only]')];
    this.jump = root.querySelector('[data-cp-jump]');
    this.bind();
    this.setMode('particulier');
  }

  bind() {
    this.modeBtns.forEach((b) => b.addEventListener('click', () => this.setMode(b.dataset.cpMode)));
    if (this.jump) this.jump.addEventListener('click', () => {
      this.setMode('pro');
      const target = this.root.querySelector('.cp__formwrap');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const first = this.root.querySelector('.cp-pro-fields input');
      if (first) setTimeout(() => first.focus({ preventScroll: true }), 500);
    });
  }

  setMode(mode) {
    const pro = mode === 'pro';
    this.modeBtns.forEach((b) => {
      const on = b.dataset.cpMode === mode;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on);
    });
    this.zones.forEach((z) => {
      const on = z.dataset.cpOnly === mode;
      z.hidden = !on;
      // Un champ masque ne doit ni bloquer la validation ni etre envoye.
      z.querySelectorAll('input, select, textarea').forEach((f) => {
        f.disabled = !on;
        if (f.hasAttribute('data-cp-req')) f.required = on;
      });
    });
    if (this.typeInput) this.typeInput.value = pro ? this.t.modePro : this.t.modePart;
    if (this.bodyLabel) this.bodyLabel.textContent = pro ? this.t.bodyLabelPro : this.t.bodyLabel;
    if (this.body) this.body.placeholder = pro ? this.t.bodyPhPro : this.t.bodyPh;
    if (this.submit) this.submit.textContent = pro ? this.t.submitPro : this.submitDefault;
  }
}

function initContactPro(scope) {
  (scope || document).querySelectorAll('[data-cp]').forEach((el) => {
    const root = el.closest('.contact-pro');
    if (!root || root.dataset.cpReady) return;
    root.dataset.cpReady = '1';
    new ContactPro(root);
  });
}

document.addEventListener('DOMContentLoaded', () => initContactPro());
document.addEventListener('shopify:section:load', (e) => initContactPro(e.target));
if (document.readyState !== 'loading') initContactPro();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-hub"] && !Shopify.designMode) return;
  try {
    
class FaqHub {
  constructor(root) {
    this.root = root;
    this.search = root.querySelector('[data-fq-search]');
    this.count = root.querySelector('[data-fq-count]');
    this.chips = [...root.querySelectorAll('[data-fq-cat]')];
    this.items = [...root.querySelectorAll('[data-fq-item]')];
    this.empty = root.querySelector('[data-fq-empty]');
    this.term = root.querySelector('[data-fq-term]');
    this.reset = root.querySelector('[data-fq-reset]');
    this.cat = 'all';
    this.items.forEach((it) => {
      const q = it.querySelector('[data-fq-q]');
      const a = it.querySelector('.fq-item__a');
      it._q = q;
      it._a = a;
      it._qHTML = q.innerHTML;
      it._aHTML = a.innerHTML;
      it._haystack = (q.textContent + ' ' + a.textContent).toLowerCase();
    });
    this.bind();
    this.openFromHash();
  }

  bind() {
    this.root.querySelectorAll('[data-fq-btn]').forEach((btn) => {
      btn.addEventListener('click', () => this.toggle(btn.closest('[data-fq-item]')));
    });
    this.chips.forEach((c) => c.addEventListener('click', () => {
      this.cat = c.dataset.fqCat;
      this.chips.forEach((o) => o.classList.toggle('is-active', o === c));
      this.filter();
    }));
    if (this.search) {
      this.search.addEventListener('input', () => this.filter());
      this.search.addEventListener('keydown', (e) => { if (e.key === 'Escape') { this.search.value = ''; this.filter(); } });
    }
    if (this.reset) this.reset.addEventListener('click', () => { this.search.value = ''; this.cat = 'all'; this.chips.forEach((o) => o.classList.toggle('is-active', o.dataset.fqCat === 'all')); this.filter(); this.search.focus(); });
    window.addEventListener('hashchange', () => this.openFromHash());
  }

  toggle(item, force) {
    const btn = item.querySelector('[data-fq-btn]');
    const open = typeof force === 'boolean' ? force : !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open);
  }

  openFromHash() {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const item = this.root.querySelector('#' + CSS.escape(id));
    if (!item || !item.matches('[data-fq-item]')) return;
    this.toggle(item, true);
    item.scrollIntoView({ block: 'center' });
  }

  escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  // Surligne sans toucher au balisage existant : on ne modifie que les noeuds texte.
  highlight(el, term) {
    const re = new RegExp(this.escapeRe(term), 'ig');
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    const targets = [];
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && re.test(node.nodeValue)) targets.push(node);
      re.lastIndex = 0;
    }
    targets.forEach((t) => {
      const frag = document.createDocumentFragment();
      let last = 0; let m;
      re.lastIndex = 0;
      while ((m = re.exec(t.nodeValue)) !== null) {
        frag.appendChild(document.createTextNode(t.nodeValue.slice(last, m.index)));
        const mark = document.createElement('mark');
        mark.textContent = m[0];
        frag.appendChild(mark);
        last = m.index + m[0].length;
        if (m[0].length === 0) re.lastIndex++;
      }
      frag.appendChild(document.createTextNode(t.nodeValue.slice(last)));
      t.parentNode.replaceChild(frag, t);
    });
  }

  filter() {
    const raw = this.search ? this.search.value.trim() : '';
    const q = raw.toLowerCase();
    let shown = 0;

    this.items.forEach((it) => {
      const catOk = this.cat === 'all' || it.dataset.cat === this.cat;
      const textOk = !q || it._haystack.indexOf(q) !== -1;
      const on = catOk && textOk;
      it.hidden = !on;
      if (on) shown++;

      it._q.innerHTML = it._qHTML;
      it._a.innerHTML = it._aHTML;
      if (q && on) {
        this.highlight(it._q, raw);
        this.highlight(it._a, raw);
        this.toggle(it, true);
      } else if (q) {
        this.toggle(it, false);
      }
    });

    if (this.count) {
      if (!q && this.cat === 'all') this.count.textContent = '';
      else this.count.textContent = shown + ' ' + (shown > 1 ? this.root.dataset.countMany : this.root.dataset.countOne);
    }
    if (this.empty) {
      const none = shown === 0;
      this.empty.hidden = !none;
      if (none && this.term) this.term.textContent = raw || this.root.dataset.emptyTheme;
    }
  }
}

function initFaqHubs(scope) {
  (scope || document).querySelectorAll('[data-fq]').forEach((el) => {
    if (el.dataset.fqReady) return;
    el.dataset.fqReady = '1';
    new FaqHub(el);
  });
}

document.addEventListener('DOMContentLoaded', () => initFaqHubs());
document.addEventListener('shopify:section:load', (e) => initFaqHubs(e.target));
if (document.readyState !== 'loading') initFaqHubs();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["material-guide"] && !Shopify.designMode) return;
  try {
    
class MaterialGuide {
  constructor(root) {
    this.root = root;
    this.cache();
    this.scores = {};
    this.labels = {};
    this.panels.forEach((p) => {
      const k = p.dataset.mgPanel;
      this.labels[k] = p.dataset.reco;
      this.scores[k] = { usage: (p.dataset.usage || '').split(',').map(Number), season: (p.dataset.season || '').split(',').map(Number) };
    });
    const u = root.querySelector('[data-mg-usage].is-active');
    const s = root.querySelector('[data-mg-season].is-active');
    this.usage = u ? +u.dataset.mgUsage : 1;
    this.season = s ? +s.dataset.mgSeason : 1;
    this.reco = this.panels.length ? this.panels[0].dataset.mgPanel : null;
    this.bind();
    this.advise();
  }

  cache() {
    const r = this.root;
    this.advisor = r.querySelector('[data-mg-advisor]');
    this.usageBtns = [...r.querySelectorAll('[data-mg-usage]')];
    this.seasonBtns = [...r.querySelectorAll('[data-mg-season]')];
    this.recoEl = r.querySelector('[data-mg-reco]');
    this.jumpBtn = r.querySelector('[data-mg-jump]');
    this.tabs = [...r.querySelectorAll('[data-mg-tab]')];
    this.panels = [...r.querySelectorAll('[data-mg-panel]')];
    this.compare = r.querySelector('[data-mg-compare]');
  }

  bind() {
    this.usageBtns.forEach((b) => b.addEventListener('click', () => { this.usage = +b.dataset.mgUsage; this.mark(this.usageBtns, b); this.advise(); }));
    this.seasonBtns.forEach((b) => b.addEventListener('click', () => { this.season = +b.dataset.mgSeason; this.mark(this.seasonBtns, b); this.advise(); }));
    this.tabs.forEach((t) => t.addEventListener('click', () => this.show(t.dataset.mgTab)));
    if (this.jumpBtn) this.jumpBtn.addEventListener('click', () => {
      this.show(this.reco);
      this.compare.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  mark(list, active) {
    list.forEach((b) => { const on = b === active; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
  }

  advise() {
    if (!this.advisor || !this.recoEl) return;
    let best = null; let bestScore = -1;
    Object.keys(this.scores).forEach((k) => {
      const sc = (this.scores[k].usage[this.usage - 1] || 0) + (this.scores[k].season[this.season - 1] || 0);
      if (sc > bestScore) { bestScore = sc; best = k; }
    });
    if (!best || best === this.reco && this.recoEl.textContent === this.labels[best]) return;
    this.reco = best;
    clearTimeout(this._swap);
    this.advisor.classList.add('is-swapping');
    this._swap = setTimeout(() => {
      this.recoEl.textContent = this.labels[this.reco];
      this.advisor.classList.remove('is-swapping');
    }, 150);
  }

  show(key) {
    this.tabs.forEach((t) => { const on = t.dataset.mgTab === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
    this.panels.forEach((p) => { const on = p.dataset.mgPanel === key; p.hidden = !on; p.classList.toggle('is-active', on); });
  }
}

function initMaterialGuides(scope) {
  (scope || document).querySelectorAll('[data-mg-compare]').forEach((el) => {
    const root = el.closest('.material-guide');
    if (!root || root.dataset.mgReady) return;
    root.dataset.mgReady = '1';
    new MaterialGuide(root);
  });
}

document.addEventListener('DOMContentLoaded', () => initMaterialGuides());
document.addEventListener('shopify:section:load', (e) => initMaterialGuides(e.target));
if (document.readyState !== 'loading') initMaterialGuides();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
class SizeGuideFinder {
  constructor(root) {
    this.root = root;
    this.t = root.dataset;
    this.data = {};
    root.querySelectorAll('[data-sg-rows]').forEach((s) => {
      try { this.data[s.dataset.sgRows] = JSON.parse(s.textContent); } catch (e) { this.data[s.dataset.sgRows] = []; }
    });
    this.cache();
    this.bind();
    if (this.tabs.length) this.setProfile(this.tabs[0].dataset.sgProfile);
  }

  cache() {
    const r = this.root;
    this.tabs = [...r.querySelectorAll('[data-sg-profile]')];
    this.pill = r.querySelector('[data-sg-pill]');
    this.chips = [...r.querySelectorAll('[data-sg-matiere]')];
    this.inputs = { chest: r.querySelector('[data-sg-input="chest"]'), hips: r.querySelector('[data-sg-input="hips"]'), height: r.querySelector('[data-sg-input="height"]') };
    this.outs = { chest: r.querySelector('[data-sg-out="chest"]'), hips: r.querySelector('[data-sg-out="hips"]'), height: r.querySelector('[data-sg-out="height"]') };
    this.fields = { chest: r.querySelector('[data-sg-field="chest"]'), hips: r.querySelector('[data-sg-field="hips"]'), height: r.querySelector('[data-sg-field="height"]') };
    this.resultEl = r.querySelector('.sg-result');
    this.sizeEl = r.querySelector('[data-sg-size]');
    this.equivEl = r.querySelector('[data-sg-equiv]');
    this.noteEl = r.querySelector('[data-sg-note]');
    this.silhouette = r.querySelector('[data-sg-silhouette]');
    this.prevEl = r.querySelector('[data-sg-prev]');
    this.currEl = r.querySelector('[data-sg-current]');
    this.nextEl = r.querySelector('[data-sg-next]');
  }

  bind() {
    this.tabs.forEach((t) => t.addEventListener('click', () => this.setProfile(t.dataset.sgProfile)));
    this.chips.forEach((c) => c.addEventListener('click', () => {
      this.chips.forEach((o) => { const on = o === c; o.classList.toggle('is-active', on); o.setAttribute('aria-checked', on); });
      this.update();
    }));
    Object.values(this.inputs).forEach((i) => {
      if (!i) return;
      i.addEventListener('input', () => this.update());
      // La molette ne doit pas modifier le curseur pendant qu'on fait defiler la page.
      i.addEventListener('wheel', (e) => { if (document.activeElement !== i) e.preventDefault(); }, { passive: false });
    });
    window.addEventListener('resize', () => this.movePill());
    if (window.ResizeObserver) new ResizeObserver(() => this.movePill()).observe(this.root);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.movePill());
  }

  setProfile(p) {
    this.profile = p;
    const tab = this.tabs.find((t) => t.dataset.sgProfile === p);
    this.mode = tab ? tab.dataset.sgMode : 'chest_hips';
    this.tabs.forEach((t) => { const on = t.dataset.sgProfile === p; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
    this.fields.chest.hidden = this.mode === 'height';
    this.fields.hips.hidden = this.mode !== 'chest_hips';
    this.fields.height.hidden = this.mode !== 'height';
    this.movePill();
    this.update();
  }

  movePill() {
    const active = this.tabs.find((t) => t.classList.contains('is-active'));
    if (!active || !this.pill) return;
    this.pill.style.width = active.offsetWidth + 'px';
    this.pill.style.transform = 'translateX(' + active.offsetLeft + 'px)';
  }

  indexFor(rows, key, value) {
    for (let i = 0; i < rows.length; i++) { if (value <= rows[i][key]) return i; }
    return rows.length - 1;
  }

  update() {
    const rows = this.data[this.profile] || [];
    Object.keys(this.inputs).forEach((k) => {
      const input = this.inputs[k];
      if (!input) return;
      const pct = ((input.value - input.min) / (input.max - input.min)) * 100;
      input.style.setProperty('--pct', pct + '%');
      if (this.outs[k]) this.outs[k].childNodes[0].nodeValue = input.value;
    });
    if (!rows.length) return;

    let idx = 0; let note = '';
    if (this.mode === 'height') {
      idx = this.indexFor(rows, 'height', +this.inputs.height.value);
      note = this.t.noteHeight;
    } else if (this.mode === 'chest') {
      idx = this.indexFor(rows, 'chest', +this.inputs.chest.value);
      note = this.t.noteChest;
    } else {
      const ic = this.indexFor(rows, 'chest', +this.inputs.chest.value);
      const ih = this.indexFor(rows, 'hips', +this.inputs.hips.value);
      idx = Math.max(ic, ih);
      note = ih > ic ? this.t.noteHips : (ic > ih ? this.t.noteChestWins : this.t.noteBoth);
    }

    const chip = this.chips.find((c) => c.classList.contains('is-active'));
    if (chip && chip.dataset.sizeUp === 'true' && idx < rows.length - 1) {
      idx += 1;
      note = chip.dataset.note || note;
    }

    const row = rows[idx];
    this._idx = idx;
    if (this.sizeEl.textContent !== row.k) {
      clearTimeout(this._swap);
      this.resultEl.classList.add('is-updating');
      this._swap = setTimeout(() => {
        this.sizeEl.textContent = rows[this._idx].k;
        this.resultEl.classList.remove('is-updating');
      }, 130);
    }
    const unit = this.t.unit ? ' ' + this.t.unit : '';
    this.equivEl.textContent = row.fr ? this.t.equiv + ' ' + row.fr : (this.mode === 'height' ? this.t.uptoHeight + ' ' + row.height + unit : this.t.uptoChest + ' ' + row.chest + unit);
    this.noteEl.textContent = note;
    this.prevEl.textContent = idx > 0 ? rows[idx - 1].k : '';
    this.currEl.textContent = row.k;
    this.nextEl.textContent = idx < rows.length - 1 ? rows[idx + 1].k : '';
    if (this.silhouette) {
      const scale = 0.88 + (idx / Math.max(1, rows.length - 1)) * 0.34;
      this.silhouette.style.transform = 'scale(' + scale.toFixed(3) + ')';
    }
  }
}

function initSizeGuides(scope) {
  (scope || document).querySelectorAll('[data-sg-finder]').forEach((el) => {
    if (el.dataset.sgReady) return;
    el.dataset.sgReady = '1';
    new SizeGuideFinder(el);
  });
}

document.addEventListener('DOMContentLoaded', () => initSizeGuides());
document.addEventListener('shopify:section:load', (e) => initSizeGuides(e.target));
if (document.readyState !== 'loading') initSizeGuides();

  } catch(e) { console.error(e); }
})();
})();
